// Pure functions for the automatic post table of contents — no DOM access.
// DOM scanning/injection lives in toc.js.

export const MIN_H2_COUNT = 4;

/**
 * Groups a flat, document-order list of {level, id, text} heading
 * descriptors into H2 entries with nested H3 children. H3s that appear
 * before the first H2 are dropped — not expected given how the editor's
 * heading tools are normally used.
 */
export function buildOutline(headings) {
    const outline = [];
    let current = null;
    for (const heading of headings) {
        if (heading.level === 2) {
            current = { id: heading.id, text: heading.text, children: [] };
            outline.push(current);
        } else if (heading.level === 3 && current) {
            current.children.push({ id: heading.id, text: heading.text });
        }
    }
    return outline;
}

function escapeHtml(value) {
    return String(value)
        .replace(/&/g, '&amp;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;')
        .replace(/"/g, '&quot;');
}

function padNum(n) {
    return String(n).padStart(2, '0');
}

function renderSublist(children) {
    if (children.length === 0) return '';
    const items = children
        .map(
            (child) =>
                `<li class="gh-toc__subitem"><a class="gh-toc__sublink" href="#${escapeHtml(child.id)}" data-toc-target="${escapeHtml(child.id)}">${escapeHtml(child.text)}</a></li>`
        )
        .join('');
    return `<ol class="gh-toc__sublist">${items}</ol>`;
}

/** Renders a full outline (see buildOutline) to a single <ol> string. */
export function renderTocListHtml(outline) {
    const items = outline
        .map(
            (entry, index) =>
                `<li class="gh-toc__item">` +
                `<a class="gh-toc__link" href="#${escapeHtml(entry.id)}" data-toc-target="${escapeHtml(entry.id)}">` +
                `<span class="gh-toc__num">${padNum(index + 1)}</span><span class="gh-toc__label">${escapeHtml(entry.text)}</span></a>` +
                `${renderSublist(entry.children)}</li>`
        )
        .join('');
    return `<ol class="gh-toc__list">${items}</ol>`;
}
